import Image from "next/image"
import React, {useContext} from "react"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import FormNewsletter from "../forms/FormNewsletter"
import {Color} from "../reusable/FormInput/FormInput"
import Button from "../reusable/components/Button"
import {ModalContext} from "../../context/ModalContext"
import AskUsEverythingModalContent from "../reusable/ModalsContent/AskUsEverythingModalContent"

type Props = {
	isAskUsDesign?: boolean
}

const BlogPostBookConsultation: React.FC<Props> = ({isAskUsDesign = false}) => {
	const {t} = useTranslation()
	const {setModalContent, closeModal, openModal} = useContext(ModalContext)

	return (
		<>
			{isAskUsDesign ? <div style={{top: 85, left: 0, borderRadius: "12px"}}
				className="container-fluid bg-grey px-2 pt-3 pt-md-0 pb-3 mt-lg-5 ">
				<div className="row justify-content-start justify-content-md-center mb-4">
					<div className="blog-post-book-consultation-sizes col-3 pt-2 mb-3 col-md-12 mb-md-4 rounded-3 overflow-hidden position-relative">
						<Image className="px-3 mt-2"
							src={"/assets/images/blog/PortraitSarina.jpg"}
							objectFit="cover"
							layout="fill"/>
					</div>
					<div className="col-9 col-md-12">
						{/* <Typography variant="bodyLgBold" semanticTag="h3" className="col-auto">{t("Du bist noch nicht bereit Deinen MyBikePlan zu starten?")}</Typography> */}
						<Typography variant="bodyLg"
							semanticTag="span"
							className="col-auto m-0">{t("Have a question?")} </Typography>
						<Typography variant="bodyLg"
							semanticTag="span"
							className="col-auto m-0">{t("Ask us anything!")}</Typography>
					</div>
				</div>
				<Button
					onClick={() => {
						setModalContent(<AskUsEverythingModalContent closeModal={closeModal} />)
						openModal()
					}}
					borderWidth={0}
					paddingX="0"
					isNoUppercase
					icon={<img src="/assets/icons/chevron-right-bg-orange.svg"/>}
					color=""
					spinnerColor="black"
					className="shadow-none mx-0 border-0"
				>
					<Typography className="me-2 text-dark"
						variant="bodyLgBold">{t("Ask us anything!", {ns: "common"})}</Typography>
				</Button>
			</div> :
				<div style={{top: 85, left: 0}}
					className="container-fluid bg-light px-3 pt-3 pt-md-0 pb-4 mt-lg-5 ">
					<div className="row justify-content-start justify-content-md-center mb-4">
						<div className="blog-post-book-consultation-sizes col-3 mb-3 col-md-12 mb-md-4 rounded-3 overflow-hidden position-relative">
							<Image src={"/assets/images/blog/PortraitSarina.jpg"}
								objectFit="cover"
								layout="fill"/>
						</div>
						<div className="col-9 col-md-12">
							<Typography variant="bodyLgBold"
								semanticTag="h3"
								className="col-auto">{t("Du bist noch nicht bereit Deinen MyBikePlan zu starten?")}</Typography>
							<Typography variant="bodyLg"
								semanticTag="p"
								className="col-auto m-0">{t("Dann melde Dich jetzt für unseren Newsletter an - Erfahre zuerst von unseren Aktionen und neuen E-Bike Marken.")}</Typography>
						</div>
					</div>
					<FormNewsletter fieldBgColor={Color.light}
						blogNewsletter/>
				</div>}
		</>
	)
}

export default BlogPostBookConsultation
